import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ProfileConfirmModalService } from '../../../../../_services/profile-settings/profile-confirm-modal.service';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';
import { Component, OnInit, Input } from '@angular/core';
import { Router , RouterModule } from '@angular/router';
import { Location, SlicePipe } from '@angular/common';
import { ActivatedRoute, Params } from '@angular/router';
@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-profile-confirm-modal',
  templateUrl: './profile-confirm-modal.component.html',
})
export class ProfileConfirmModalComponent implements OnInit {
  @Input() toDo: string;
  profileAccountModalOptions: ModalOptions;
  hideModalOnRoute = false;
  @Input() from: string;
  policyId: any;
  @Input() selectedPolicyId: any;
  @Input() bankAccount: any;
  isAcmic = false;

  constructor(
    public router: Router,
    private profileConfirmModalService: ProfileConfirmModalService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private slicePipe: SlicePipe,
    private acmicService: AcmicService
  ) {
    this.isAcmic = this.acmicService.isACMIC();
  }

  resetHideModal(): void {
    this.profileConfirmModalService.onRestoreDefault();
    this.hideModalOnRoute = !this.hideModalOnRoute;
  }

  closeModal() {
    this.profileConfirmModalService.resetRemoveAccount();
  }

  onRemoveCheckingAccount(removeAccount: string) {
    this.hideModalOnRoute =
      this.profileConfirmModalService.onRemoveCheckingAccount(
        removeAccount,
        this.selectedPolicyId,
        this.bankAccount
      );
  }

  onClickBack(onclick: string) {
    if (this.from === 'residential_address_change' && onclick === 'back') {
      this.location.back();
    } else if (this.from === 'add-policy' && onclick === 'back') {
      this.router.navigate(['/my-insurance']);
    } else {
      this.hideModalOnRoute =
        this.profileConfirmModalService.onClickBack(onclick);
    }
  }

  ngOnInit() {
    if (this.bankAccount) {
      const lastFoutDigits: any = this.slicePipe.transform(
        this.bankAccount,
        -4
      );
      let initialDigits: any = this.slicePipe.transform(
        this.bankAccount,
        0,
        -4
      );
      initialDigits = initialDigits.replace(/\d/g, 'x');
      this.bankAccount = initialDigits + lastFoutDigits;
    }
    this.profileAccountModalOptions = new ModalOptions({
      additionalClasses: `modal-small ${
        this.isAcmic ? '' : 'modal-medium'
      } modal-dialog center-on-page confirm-modal`,
      animatePosition: 'top',
      onLoad: true,
      modalId: 'accountModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      modalTranslateCopy: this.isAcmic
        ? this.toDo === 'removeAccount'
          ? 'REMOVE_CHECKING_ACCOUNT'
          : 'PLEASE_CONFIRM'
        : '',
      typeOfModal: 'accountConfirm',
      screenReader: true,
      showIcons: true,
      modalName: 'profile_Confirm',
    });
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params['policyid'];
    });
  }
}
